import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngx-datatable-header-template]'
})
export class DataTableColumnHeaderDirective {
  template = inject<TemplateRef<unknown>>(TemplateRef);

}
